<template>
    <!-- BEGIN: Content-->
    <div class="customersList">
      <v-container fluid>

        <v-row>
          <v-col md="12" sm="12" class="d-flex" style="justify-content:space-between">
            <v-breadcrumbs
              :items="breadcrumbs"
              divider="/"
            ></v-breadcrumbs>

            <v-btn
              color="#000000"
              class="white--text"
              depressed
              @click.stop="dialog = true"
            >
              Customer
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>

          </v-col>
        </v-row>

        <v-row>
          <v-col md="12" sm="12">
            <v-card class="card-shadow py-3">
              <v-data-table
                dense
                :headers="fields"
                :items="customers"
                class="elevation-0"
                loading="false"
                loading-text="Loading... Please wait"
              >
                <template v-slot:item.#="{ item }">
                  {{ item.created_at }}
                </template>
                <template v-slot:item.name="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item.telephone="{ item }">
                  {{ item.telephone }}
                </template>
                <template v-slot:item.email="{ item }">
                  {{ item.email }}
                </template>
                <template v-slot:item.address="{ item }">
                  {{ item.address }}
                </template>
                <template v-slot:item.postalcode="{ item }">
                  {{ item.postalcode }}
                </template>
                <template v-slot:item.city="{ item }">
                  {{ item.city }}
                </template>
                <template v-slot:item.country="{ item }">
                  {{ item.country }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="edit(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteq(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <!-- add user dialog -->
      <v-dialog
        v-model="dialog"
        max-width="600px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add Customer</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Name*"
                      v-model="item.name"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Telephone*"
                      v-model="item.telephone"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Email*"
                      v-model="item.email"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Address*"
                      v-model="item.address"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Postal Code*"
                      v-model="item.postalcode"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="City*"
                      v-model="item.city"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-autocomplete
                      :items="['Kenya', 'Uganda', 'Tanzania']"
                      label="Select country*"
                      v-model="item.country"
                      :rules="fieldRules"
                      :search-input.sync="searchcountry"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="create"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- end user -->

      <!-- user update modal-->
      <v-dialog
        v-model="updatedialog"
        max-width="600px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Update Customer</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Name*"
                      v-model="item.updatename"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Telephone*"
                      v-model="item.updatetelephone"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Email*"
                      v-model="item.updateemail"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Address*"
                      v-model="item.updateaddress"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Postal Code*"
                      v-model="item.updatepostalcode"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="City*"
                      v-model="item.updatecity"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-autocomplete
                      :items="['Kenya', 'Uganda', 'Tanzania']"
                      label="Select country*"
                      v-model="item.updatecountry"
                      :value="item.updatecountry"
                      :rules="fieldRules"
                      :search-input.sync="searchcountry"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="updatedialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="update"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update user -->

    </div>

</template>

<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import {ability} from '../../services/ability'

export default {
    name:"customersList",
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          searchcountry: null,
          updatedialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'Products',
              disabled: false,
              href: '',
            },
            {
              text: 'Sub Categories',
              disabled: false,
              href: '',
            },
          ],
          fields: [
             {
              text: '#',
              align: 'start',
              value: 'created_at',
            },
            { text: 'Name', value: 'name' },
            { text: 'Telephone', value: 'telephone' },
            { text: 'Email', value: 'email' },
            { text: 'Address', value: 'address' },
            { text: 'Postalcode', value: 'postalcode' },
            { text: 'City', value: 'city' },
            { text: 'Country', value: 'country' },
            { text: 'Action', value: 'action' },
           ],
          item:{
                name:"",
                telephone:"",
                email: "",
                address:"",
                postalcode:"",
                city:"",
                country:"",

                updatename:"",
                updatetelephone:"",
                updateemail: "",
                updateaddress:"",
                updatepostalcode:"",
                updatecity:"",
                updatecountry:"",

                updateID: "",
                _method:"patch"
            },
            loading: false,
           disabled: false,
           isBusy: false,
            updateModal: null
        }
    },
    beforeMount() {
      if(!ability.can('inventory-management', 'all')) {
        this.$router.push({ name: 'Pos' })
        return
      }
    },
    mounted(){
      if(!this.customers || this.customers.length == 0) {
        this.getCustomers()
      }
    },
    computed: {
      customers() {
        return this.$store.state.customers
      },
    },
    methods:{
      async getCustomers(){
        this.isBusy = true
        await axios.get('/customers').then(response=>{
            this.$store.state.customers = response.data.customers
        }).catch(error=>{
            console.log(error)
        })
      },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('name',this.item.name)
            fd.append('telephone',this.item.telephone)
            fd.append('email',this.item.email)
            fd.append('address',this.item.address)
            fd.append('postalcode',this.item.postalcode)
            fd.append('city',this.item.city)
            fd.append('country',this.item.country)

            await axios.post('/customers', fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === parseInt(200))
                this.$toast.success("Customer added successfully",'Success',{position: 'topRight',timeout: 7000,})
                this.getCustomers()
                this.clear()
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

        }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('name',this.item.updatename)
            fd.append('telephone',this.item.updatetelephone)
            fd.append('email',this.item.updateemail)
            fd.append('address',this.item.updateaddress)
            fd.append('postalcode',this.item.updatepostalcode)
            fd.append('city',this.item.updatecity)
            fd.append('country',this.item.updatecountry)
            fd.append('_method',this.item._method)

            await axios.post(`/customers/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === parseInt(200))
                this.$toast.success("Customer updated successfully",'Success',{position: 'topRight',timeout: 7000,})
                this.updatedialog = false
                this.getCustomers()
              this.clear()
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async edit(id) {
        let index = this.customers.filter(item => item.id === id );
        this.item.updatename = index[0].name
        this.item.updatetelephone = index[0].telephone
        this.item.updateemail = index[0].email
        this.item.updateaddress = index[0].address
        this.item.updatepostalcode = index[0].postalcode
        this.item.updatecity = index[0].city
        this.item.updatecountry = index[0].country

        this.item.updateID = index[0].id
        this.updatedialog = true
      },
      deleteq(id){
            if(confirm("Are you sure to delete customer ?")){
                axios.delete(`/customers/${id}`).then(response=>{
                  this.$toast.success('Customer deleted successfully','Success',{position: 'topRight',timeout: 7000,})
                    this.getCustomers()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }

    }
}
</script>